import { render, staticRenderFns } from "./WhatsappChatStarterWithZoho.vue?vue&type=template&id=04888d58&scoped=true"
import script from "./WhatsappChatStarterWithZoho.vue?vue&type=script&lang=js"
export * from "./WhatsappChatStarterWithZoho.vue?vue&type=script&lang=js"
import style0 from "./WhatsappChatStarterWithZoho.vue?vue&type=style&index=0&id=04888d58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04888d58",
  null
  
)

export default component.exports